import React, { ChangeEvent, useState } from "react";
import FormInput from "../FormInput";
import SvgIcon from "../../assets/icons/SvgIcon";

interface IProps {
  name?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
  handleChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const Password: React.FC<IProps> = ({
  name,
  label,
  placeholder = "Enter your password",
  required = false,
  className,
  handleChange,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <FormInput
      id={"password"}
      type={showPassword ? "text" : "password"}
      label={label ?? "Password"}
      name={name ?? "password"}
      className={className}
      placeholder={
        placeholder.charAt(0).toUpperCase() + placeholder.slice(1).toLowerCase()
      }
      required={required}
      customElement={
        <button
          type="button"
          onClick={() => {
            setShowPassword(!showPassword);
          }}
          className="absolute top-4 right-5"
        >
          <SvgIcon iconName={showPassword ? "eye" : "eye-slash"} />
        </button>
      }
      handleChange={handleChange}
    />
  );
};

export default Password;
